<template>
    <page>
        <module enable-flex ref="view">
            <m-search ref="search" @search="searchHandle">
                <c-form>
                    <c-form-item type="input" label="会员昵称" name="nick_name"></c-form-item>
                    <c-form-item type="input" label="会员手机号" name="user_manage_mobilephone"></c-form-item>
                    <c-form-item type="input" label="邀请人手机" name="share_user_manage_mobilephone"></c-form-item>
<!--
					<c-form-item type="input" label="上级代理手机" name="leader_user_manage_mobilephone"></c-form-item>
-->
                    <c-form-item type="select" label="会员等级" name="user_level" options="USER_LEVEL_AUTH"></c-form-item>
                    <c-form-item type="checkbox" label="用户状态" name="state" :options="stateType"></c-form-item>
					<c-form-item type="checkbox" label="私有店铺" name="shop_states" :options="shopStateType"></c-form-item>
                </c-form>
            </m-search>
            <m-operate>
                <c-button color="black" hollow @click="backHigher" v-if="higherLevel.platform_user_id">返回</c-button>
                <span v-if="higherLevel.platform_user_id"
                      style="margin-left: 10px; font-size: 13px;">上级：{{ `${higherLevel.nick_name}(${higherLevel.user_manage_mobilephone})` }}</span>
                <c-button power="b_member_user_init_station" color="m" hollow @click="initStationedOpen()">初始化开通商家</c-button>
                <c-button color="m" hollow @click="syncExport()">导出</c-button>
                <!--右侧通用菜单-->
                <template #right>
                    <c-button v-if="userInfo.id == 1" color="red" @click="$refs.view.editExportColumn(workType)">
                        编辑导出列
                    </c-button>
                </template>
            </m-operate>
            <c-table ref="table">
                <c-table-column type="selector" ></c-table-column>

				<c-table-column
				    label="会员头像/昵称/等级"
				    name="head_photo"
				    width="200"
				>
				    <template v-slot="{data}">
				        <div class="flex-center-cross">
							<c-image :src="data.head_photo" preview size="35" style="margin-right: 10px;"></c-image>
							<div>
								<span>{{data.nick_name}}</span><br>
								<span style="color:blue">{{data.user_level_name}}</span>
							</div>
				        </div>
				    </template>
				</c-table-column>
				
                <c-table-column label="会员手机号" name="user_manage_mobilephone" width="120">
                    <template v-slot="{data}">
                        <a v-if="data.user_level > 0 && data.direct_count > 0" class="s-link"
                           @click="loadLower(data)">
                            ↓ {{ data.user_manage_mobilephone }}
                        </a>
                        <span v-else>{{ data.user_manage_mobilephone }}</span>
                    </template>
                </c-table-column>
                <c-table-column label="邀请人" name="share_user_manage_mobilephone" width="200">
                    <template v-slot="{data}">
                              <span v-if="data.platform_user_id == -1" style="color:#bbb">-</span>
                              <div class="flex-center-cross" v-else>
								<c-image :src="data.share_user_head_photo" preview size="35" style="margin-right: 10px;"></c-image>
								<div>
								  <span style="color:blue">{{data.share_user_level_name||'-'}}</span><br/>
								  <span>{{data.share_user_nick_name||'-'}}</span>
								</div>
                              </div>
                    </template>
                </c-table-column>
				
				<c-table-column label="邀请人手机号" name="user_manage_mobilephone" width="120">
				    <template v-slot="{data}">
						<span v-if="data.platform_user_id == -1" style="color:#bbb">-</span>
				        <span v-else>{{ data.share_user_manage_mobilephone }}</span>
				    </template>
				</c-table-column>
                
                <!-- <c-table-column label="上级经销商" name="leader_user_manage_mobilephone" width="200">
					<template v-slot="{data}">
                		<span v-if="!data.leader_user_level_name" style="color:#bbb">-</span>
                		<div class="flex-center-cross" v-else>
							<c-image :src="data.leader_user_head_photo" preview size="55" style="margin-right: 10px;"></c-image>
							<div>
								<span>{{data.leader_user_manage_mobilephone||'-'}}</span><br/>
								<span style="color:blue">{{data.leader_user_level_name||'-'}}</span><br/>
								<span>{{data.leader_user_nick_name||'-'}}</span>
							</div>
                		</div>
					</template>
                </c-table-column> -->
                <c-table-column label="直推会员数" name="direct_count" width="100">
                    <template v-slot="{data}">
                        <a v-if="data.user_level > 0 && data.direct_count > 0" class="s-link"
                           @click="loadLower(data)">
                            {{ data.direct_count }}&nbsp;↓&nbsp; 
                        </a>
                        <span v-else>{{ data.direct_count }}</span>
                    </template>
                </c-table-column>
                <c-table-column label="间推会员数" name="indirect_count" width="100">
                </c-table-column>
                <c-table-column label="状态" name="state" width="80">
                    <template v-slot="{data}">
                        <span v-if="data.state == 2" style="color:red">禁用</span>
                        <span v-if="data.state == 1" style="color:green">启用</span>
                    </template>
                </c-table-column>
				<c-table-column
					label="货款余额(元)" name="account_balance" width="110">
					<template v-slot="{data}">
						￥{{(data.account_balance||0).toFixed(2)}}
					</template>
				</c-table-column>
                <c-table-column label="收益账户" name="account" width="100">
                    <template v-slot="{data}">
                        ￥{{ (data.reward_balance || 0).toFixed(2) }}
                    </template>
                </c-table-column>
				<c-table-column label="加入会员时间" name="upgrade_date" width="140">
				</c-table-column>
				<c-table-column
					label="私有店铺"
					name="shop_id"
					width="80"
					v-if="systemConfig.oms_seller_shop_enabled == 'ON'"
				>
				  <template v-slot="{data}">
				    <span v-if="data.shop_id == 0" style="color:#bbb">未开通</span>
				    <span v-else style="color:darkgreen">已开通</span>
				  </template>
				</c-table-column>
                <c-table-column type="button" fixed="right" label="操作" width="310" limit="4">
                    <template v-slot="{data}">
                        <c-table-button power="b_member_user_view_symx" @click="viewReward(data)"> 收益明细 </c-table-button>
                        <c-table-button power="b_member_user_change" v-if="data.platform_user_id > 0" @click="$refs.memberUpgrade.open(data)">代理调整</c-table-button>
                        <c-table-button power="b_member_user_change" v-if="data.platform_user_id > 0" @click="agentOpenRegin(data)">代理区域</c-table-button>
						<c-table-button power="b_member_user_shop" v-if="systemConfig.oms_seller_shop_enabled == 'ON' && data.shop_id == 0 && data.platform_user_id > 0" @click="openShop(data)">开通店铺</c-table-button>
                        <c-table-button power="b_member_user_change" v-if="data.platform_user_id > 0" @click="showMemberUpgradeRecord(data)">调整记录</c-table-button>
                        <!-- <c-table-button power="b_member_edit_cloud_stock" v-if="systemConfig.cloud_stock == 'ON' && data.user_level >= systemConfig.cloud_stock_level" @click="setCloudStock(data)">云仓库存</c-table-button> -->
                    </template>
                </c-table-column>
            </c-table>
        </module>
        <c-dialog ref="rewardDialog" title="收益明细" width="1200" height="800" enable-flex :button="false">
            <m-search ref="rewardSearch" @search="rewardSearchHandle">
                <c-form ref="form" inline>
                    <c-form-item type="checkbox" label="收益类型" name="reward_type" :options="rewardTypeOptions">
                    </c-form-item>
                    <c-form-item type="checkbox" label="收益状态" name="state" :options="stateOptions">
                    </c-form-item>
                    <c-form-item type="datetime" label="创建时间" start-name="start_date" end-name="end_date">
                    </c-form-item>
                </c-form>
            </m-search>
            <c-table ref="rewardTable" height="grow">
                <c-table-column
                	label="结算流水号"
                	name="record_number"
                	width="120"
                ></c-table-column>
                
                <c-table-column
                	label="结算类型 "
                	name="reward_type"
                	width="100"
                >
                	<template v-slot="row">
                		{{rewardTypeName[row.data.reward_type]}}
                	</template>
                </c-table-column>
                
                <c-table-column
                	label="业务类型"
                	name="order_type"
                	width="80"
                >
                	<template v-slot="row">
                		<span v-if="row.data.order_type==1" style="color:lightsalmon">代理订单</span>
                		<span v-else style="color:lightseagreen">销售订单</span>
                	</template>
                </c-table-column>
                
                <c-table-column
                	label="业务单号"
                	name="relate_number"
                	width="125"
                ></c-table-column>
                
                <c-table-column
                	label="订单总额"
                	name="payment_money"
                	width="80"
                >
                	<template v-slot="row">
                	    ¥{{parseFloat(parseFloat(row.data.product_money).toFixed(2))}}
                	</template>
                </c-table-column>
                
                <c-table-column
                	label="已支付金额"
                	name="payment_money"
                	width="90"
                >
                	<template v-slot="row">
                	    <span style="color:green;">¥{{parseFloat(parseFloat(row.data.payment_money).toFixed(2))}}</span>
                	</template>
                </c-table-column>
                
                <c-table-column
                	label="待支付尾款"
                	width="90"
                >
                	<template v-slot="row">
                	    <span v-if="(row.data.product_money-row.data.payment_money) > 0" style="color:red">
                			¥{{parseFloat(parseFloat(row.data.product_money-row.data.payment_money).toFixed(2))}}
                		</span>
                		<span v-else>-</span>
                	</template>
                </c-table-column>
				
				<c-table-column
					label="佣金比例"
					width="80"
				>
					<template v-slot="row">
						<span style="color:blue;">{{parseFloat((parseFloat(row.data.record_ratio)*100).toFixed(2))}}%</span>
					</template>
				</c-table-column>
                
                <c-table-column
                	label="可结算金额"
                	name="estimated_record_money"
                	width="90"
                >
                	<template v-slot="row">
                	    <span style="color:blue;">¥{{parseFloat(parseFloat(row.data.estimated_record_money).toFixed(2))}}</span>
                	</template>
                </c-table-column>
                
                <c-table-column
                	label="预计最终结算金额"
                	name="original_record_money"
                	width="130"
                >
                	<template v-slot="row">
                		<span style="color:gray;">¥{{parseFloat(parseFloat(row.data.original_record_money).toFixed(2))}}</span>
                	</template>
                </c-table-column>
                
                <c-table-column
                	label="已结算金额"
                	name="record_money"
                	width="100"
                >
                	<template v-slot="row">
                	    <span v-if="row.data.state == 2" style="color:green;">
                			¥{{parseFloat(parseFloat(row.data.record_money).toFixed(2))}}
                		</span>
                		<span v-else>-</span>
                	</template>
                </c-table-column>
                
                <c-table-column
                	label="结算状态"
                	name="state"
                	width="75"
                >
                	<template v-slot="{data}">
                        <span v-if="data.state==0" style="color:darkgray">{{transStateName[data.state]}}</span>
                        <span v-if="data.state==1" style="color:#2348d0">{{transStateName[data.state]}}</span>
                		<span v-if="data.state==2" style="color:darkgreen">{{transStateName[data.state]}}</span>
                	</template>
                </c-table-column>
                
                <c-table-column
                	label="结算说明"
                	name="remark"
                	width="270"
                ></c-table-column>
                
                <c-table-column
                	label="生成时间"
                	name="create_date"
                	width="140"
                ></c-table-column>
                
                <c-table-column
                	label="最近更新时间"
                	name="update_date"
                	width="140"
                ></c-table-column>
                
                <c-table-column
                	label="取消时间"
                	name="cancel_date"
                	width="140"
                >
                	<template v-slot="{data}">
                	    <span v-if="data.cancel_date" style="color:darkgray">{{data.cancel_date}}</span>
                	    <span v-else>-</span>
                	</template>
                </c-table-column>
            </c-table>
        </c-dialog>
		
		<!--开通店铺 -->
		<c-dialog ref="shopEdit" title="开通分销商店铺" width="600" @resolve="submitShop">
			<c-form ref="shopForm">
				<c-form >
					<c-form-item type="input" label="经销商名称" name="company_name" maxlength="30" required></c-form-item>
					<c-form-item type="input" label="店铺名称" name="shop_name" maxlength="50" required></c-form-item>
					<c-form-item type="region" label="店铺地址"
		                         province-name="delivery_province_id"
		                         city-name="delivery_city_id"
		                         county-name="delivery_county_id"
		                         required></c-form-item>
					<c-form-item type="input" name="address" maxlength="150"></c-form-item> 
					<c-form-item type="hidden" name="platform_user_id"></c-form-item>
		            <c-form-item type="select" label="分销商角色" name="auth_id" options="SELLER_AUTH" required></c-form-item>
				</c-form>
				<!-- <c-form title="配置信息"> -->
					<!-- <c-form-item type="radio" label="清分方式" name="liquidation_type" :options="liquidationType" required></c-form-item>
					<c-form-item type="number" label="" name="liquidation_date" :limit="[0,100]" word="天"></c-form-item> -->
				<!-- </c-form> -->
			</c-form>
		</c-dialog>
		
        <!--云仓库存编辑-->
        <c-dialog ref="stockEdit" :title="stockEditTitle" width="1000" height="620" enable-flex  @resolve="setStockHandle">
            <m-search ref="stockSearch" @search="stockSearchHandle">
                <c-form ref="stockForm" inline>
                    <c-form-item type="input" label="商品信息" name="product_info" placeholder="模糊匹配货号、名称"></c-form-item>
                    <c-form-item type="input" label="商品规格" name="product_sku_spec" placeholder="模糊匹配商品规格"></c-form-item>
                    <c-form-item type="input" label="SKU编码" name="product_sku_code" placeholder="精确匹配"></c-form-item>
                    <c-form-item type="checkbox" label="" name="isStock" :options="[{name: '有库存',value: 1}]"></c-form-item>
                </c-form>
            </m-search>
            <c-table ref="stockTable" height="500">
                <c-table-column
                        label="商品信息"
                        name="product_name"
                        width="300"
                >
                    <template v-slot="{data}">
                        <product-info v-if="data.product_itemnumber" :image="data.product_img_url" :name="data.product_itemnumber + ' - '+data.product_name"></product-info>
                        <product-info v-else :image="data.product_img_url" :name="data.product_name"></product-info>
                    </template>
                </c-table-column>

                <c-table-column
                        label="规格名称"
                        name="product_sku_spec"
                        width="120"
                ></c-table-column>

                <c-table-column
                        label="SKU编码"
                        name="product_sku_code"
                        width="150"
                ></c-table-column>

                <c-table-column
                        label="当前库存"
                        name="product_count"
                        width="70"
                >
                </c-table-column>

                <c-table-column
                        width="100"
                >
                    <template slot="head">
                        <div class="flex-center-cross">
                            <span>增减库存</span>
                            <a style="margin-left: 10px;" @click="$refs.batchStockDialog.open()"><i class="tf tf-edit"></i></a>
                        </div>
                    </template>
                    <template v-slot="{data}">
                        <c-input v-model="data.revise_stock" type="number" :limit="[-data.product_count, 9999]"></c-input>
                    </template>
                </c-table-column>

                <c-table-column
                        label="调整后库存"
                        name="new_product_count"
                        width="120"
                >
                    <template v-slot="{data}">
                        {{parseInt(data.product_count) + (parseInt(data.revise_stock) || 0)}}
                    </template>
                </c-table-column>
            </c-table>
        </c-dialog>
        <c-dialog ref="batchStockDialog" title="批量增/减库存" width="400" height="140" @resolve="batchSetStock">
            <c-form ref="batchStockForm">
                <c-form-item type="number" label="增/减库存" name="value"></c-form-item>
            </c-form>
        </c-dialog>
        <c-dialog ref="memberAgentListDialog" :title="open_regin_title" width="600">
            <c-table v-if="open_regin_list && open_regin_list.length>0" ref="memberAgentListTable" :paging="false" :value="open_regin_list" height="300" >
                <c-table-column
                        label="代理类型"
                        name="agent_type"
                        width="120"
                >
                    <template v-slot="{data}">
                        <span v-if="data.agent_type == 3">爆款代理</span>
                        <span v-if="data.agent_type == 2">市级代理</span>
                        <span v-if="data.agent_type == 1">省级代理</span>
                    </template>
                </c-table-column>
                <c-table-column
                        label="开通类目"
                        name="type_name"
                        width="120"
                ></c-table-column>
                <c-table-column
                        label="开通区域"
                        name="regin_names"
                        width="260"
                ></c-table-column>
            </c-table>
            <div v-else style="padding: 20px; height: 100px;">
                <p>暂未开通代理</p>
            </div>
        </c-dialog>
        <member-upgrade-record ref="memberUpgradeRecord"></member-upgrade-record>
        <member-upgrade ref="memberUpgrade" @resolve="$refs.table.update()"></member-upgrade>
    </page>
</template>
<script>
import {mapState} from "vuex";
import productInfo from '@/components/public/product_info.vue'
import memberUpgradeRecord from '@/components/service/member_user_upgrade_record.vue'
import memberUpgrade from "@/components/service/member_user_upgrade.vue";

export default {
    name: 'm_member_user',

    components: {
        productInfo,
        memberUpgradeRecord,
        memberUpgrade
    },

    data() {
        return {
            workType: 13,
            searchParams: {},
			transStateName: {
			    0: '取消结算',
			    1: '待结算',
			    2: '已结算'
			},
			stateOptions: [
				{name: '待结算',value: 1},
				{name: '取消结算',value: 0},
				{name: '已结算',value: 2}
			],
			orderTypeOptions: [
				{name: '代理订单',value: 1},
				{name: '销售订单',value: 2}
			],
			rewardTypeOptions: [
				{name: '直推奖励',value: 2},
				{name: '间推奖励',value: 3},
				{name: '爆款代理费',value: 201},
				{name: '专业代理费',value: 202},
				{name: '市代代理费',value: 203},
				{name: '省代代理费',value: 204},
				{name: '业务员代理费',value: 205}
			],
			rewardTypeName:{
				2: '直推奖励',
				3: '间推奖励',
				201: '爆款代理费',
				202: '专业代理费',
				203: '市代代理费',
				204: '省代代理费',
				205: '业务员代理费'
			},
            stateType: [
                {name: '启用', value: 1},
                {name: '禁用', value: 2}
            ],
			shopStateType: [
				{name: '未开通', value: 1},
				{name: '已开通', value: 2}
			],
            levelList: [],
            member_user_id: '',
            recommend_type: '',
            stockEditTitle:'云仓库存',
            open_regin_list:[],
            open_regin_title:'已开通代理'
        }
    },

    computed: {
        ...mapState(['systemConfig', 'userInfo']),
        higherLevel() {
            return this.levelList[this.levelList.length - 1] || {};
        }
    },

    watch: {
        higherLevel(val) {
            this.$refs.search.clear();
            this.searchHandle();
        }
    },

    mounted() {
        this.$refs.search.search();
    },

    methods: {
        /*************显示会员调整日志配置**********/
        showMemberUpgradeRecord(data) {
            var title = '会员【' + data.user_manage_mobilephone + '(' + (data.nick_name || '--') + ')】调整记录';
            this.$refs.memberUpgradeRecord.open({
                platform_user_id: data.platform_user_id,
                title: title
            });
        },

        viewReward(val) {
            this.$refs.rewardDialog.open();
            this.member_user_id = val.platform_user_id;
            this.$refs.rewardTable.load({
                url: '/member_user/reward/list',
                data: {
                    member_user_id: val.platform_user_id,
                }
            });
        },

        rewardSearchHandle(data) {
            data.member_user_id = this.member_user_id;
            this.$refs.rewardTable.load({
                url: '/member_user/reward/list',
                data
            });
        },

        searchHandle(data = {}) {
            data.member_user_id = this.higherLevel.platform_user_id;
            this.$refs.table.load({
                url: '/member_user/list',
                data
            });
            this.searchParams = data || {};
        },

        detail(val) {
            this.navigateTo({
                path: '/member_detail/' + val.platform_user_id,
            });
        },

        loadLower(data) {
            this.levelList.push(data);
        },

        backHigher() {
            this.levelList.splice(this.levelList.length - 1, 1);
        },
		
		//开通店铺
		openShop(val) {
		    this.$refs.shopForm.clear();
		    val.company_name = val.nick_name;
		    val.shop_name = val.nick_name + '的小店';
		    this.$refs.shopForm.set(val);
		    this.$refs.shopEdit.open();
		},
		
		//提交 开通分销商店铺 数据
		submitShop(stop) {
		    stop();
		    this.$refs.shopForm.submit({
		        url: '/platform_user/openShop',
		        rule: {
		            company_name: '请输入经销商名称',
		            shop_name: '请填写店铺名称',
					delivery_county_id: '请选择店铺地址所在省市县信息',
					address: '请填写店铺详细地址',
		            auth_id: '请选择分销商家角色',
		            // liquidation_type: '请选择清分方式',
		            // liquidation_date: '请输入清分延迟天数'
		        },
		        dataFormatter: data => {
				  data.liquidation_type = 1;
				  data.liquidation_date = 0;
		            return data;
		        },
		        success: (data, res, msg) => {
		            this.$confirm({
		                icon: 'success',
		                text: msg,  // 提示内容,
		                buttonName: '确定',  // 确定按钮文字
		                cancelButton: false  // 是否显示取消按钮
		            });
		            this.$refs.table.update();
		            this.$refs.shopEdit.close();
		        }
		    });
		},

        //云仓库存弹窗
        setCloudStock(item) {
            this._setUserId = item.platform_user_id;
            this.stockEditTitle = '会员【'+item.user_manage_mobilephone+'】';
            if (item.nick_name){
                this.stockEditTitle += '('+item.nick_name+')';
            }
            this.stockEditTitle += ' - 云仓库存信息';
            this.$refs.stockEdit.open();
            this.$refs.stockForm.clear();
            this.$refs.stockForm.set({isStock: [1]});
            this.stockSearchHandle({isStock: [1]});
        },

        //查询云仓库存
        stockSearchHandle(data) {
            data.platform_user_id = this._setUserId;
            this.$refs.stockTable.load({
                url: '/cloud/stock/list',
                data
            });
        },
        //批量设置云仓库存
        batchSetStock() {
            let n = parseFloat(this.$refs.batchStockForm.serialize().value);
            if (n == n) {
                this.$refs.stockTable.getRow().forEach(item => {
                    item.data.revise_stock = n;
                })
            }
            this.$refs.batchStockForm.clear();
        },
        //提交云仓库存设置数据
        setStockHandle(stop) {
            stop();
            var stockList = this.$refs.stockTable.getRow().filter(item => ((parseInt(item.data.revise_stock) || 0) !=0));
            if(stockList.length ==0){
                this.$message({
                    text: '您未做任何库存变更！'
                });
                return;
            }
            this.request({
                url: '/cloud/stock/edit',
                data: {
                    platform_user_id: this._setUserId,
                    product_sku_stock_list: Array.from(stockList, item => {
                        return {
                            product_id: item.data.product_id,
                            product_sku: item.data.product_sku,
                            product_count: parseInt(item.data.product_count) + (parseInt(item.data.revise_stock) || 0)
                        }
                    })
                },
                loading: true,
                success: data => {
                    this.$message({
                        text: '云仓库存调整成功',
                        icon: 'success'
                    });
                    //刷新列表
                    this.$refs.stockTable.update();
                }
            });
        },
        /**同步导出数据*/
        syncExport(){
            var selectDatas = this.$refs.table.getRow('selected');
            var ids = [];
            if (selectDatas.length && selectDatas.length>0) {
                ids = Array.from(selectDatas, item => item.data.platform_user_id);
            }
            this.export(this.workType,this.searchParams,ids);
        },
        /**代理开通区域*/
        agentOpenRegin(data){
            this.open_regin_title = '会员【'+(data.nick_name||data.user_manage_mobilephone)+'】 - 代理开通区域';
            this.request( {
                url: '/platform_user/agent/open_list',
                data: {
                    platform_user_id: data.platform_user_id
                },success: data => {
                    this.open_regin_list = data||[];
                    this.$refs.memberAgentListDialog.open();
                }
            })
        },
        initStationedOpen(){
            this.$confirm({
                text: '确定要为普通代理初始化开通商家吗？',
                resolve: () => {
                    this.request({
                        url: '/platform_user/agent/init_stationed_open',
                        data: {
                        },
                        loading: true,
                        success: data => {
                            this.$message({
                                text: '操作成功'
                            });
                            this.$refs.table.update();
                        }
                    });
                }
            });
        }
    }
}
</script>